import { document } from '../../env/browser';
import getGlobalValue from '../../utils/get-global-value';
import { WSB_MERCHANT_SOURCE } from '../constants/merchant';

// Gravity emits its tokens under `.gv-activated`, never `:root` — so a second
// brand sheet would win for the whole page no matter where it sits. One link,
// href swapped; never two.

const GRAVITY_CDN_ORIGIN = '//gravity.group-cdn.one';

export const GRAVITY_BRAND_LINK_ID = 'gravity-brand';
export const GRAVITY_BRAND_WSB = 'one-rebrand';
export const GRAVITY_BRAND_FALLBACK = 'shore';
export const GRAVITY_BRAND_TIMEOUT_MS = 2000;

const config = () =>
  (getGlobalValue('Shore.config') ?? {}) as Record<string, string>;

export const gravityBrandCssUrl = (brand: string): string =>
  `${GRAVITY_CDN_ORIGIN}/${config().GRAVITY_VERSION}/css/brands/${brand}.css`;

export const getGravityBrand = (merchantSource?: string): string =>
  merchantSource === WSB_MERCHANT_SOURCE
    ? GRAVITY_BRAND_WSB
    : config().GRAVITY_BRAND || GRAVITY_BRAND_FALLBACK;

export function applyGravityBrand(merchantSource?: string): Promise<void> {
  const link = document.getElementById(
    GRAVITY_BRAND_LINK_ID
  ) as HTMLLinkElement | null;

  if (!link) return Promise.resolve();

  const nextHref = gravityBrandCssUrl(getGravityBrand(merchantSource));

  if (link.getAttribute('href') === nextHref) return Promise.resolve();

  return new Promise<void>((resolve) => {
    let timer: ReturnType<typeof setTimeout>;
    let settled = false;

    // Resolves on `error` and on timeout too: a dead CDN must degrade to
    // unbranded, never hang bootstrap.
    const done = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      link.removeEventListener('load', done);
      link.removeEventListener('error', done);
      resolve();
    };

    timer = setTimeout(done, GRAVITY_BRAND_TIMEOUT_MS);
    link.addEventListener('load', done);
    link.addEventListener('error', done);
    link.setAttribute('href', nextHref);
  });
}
